module.exports = __webpack_public_path__ + "static/media/2.question.8e1ddb26.mp4";